import {
  isNotRemoved,
  isDeleting,
  isToBagInProgress
} from "../../../selectors/itemStateSelectors";
import { ITEM_STATE_TO_BAG_COMPLETE } from "../../../constants";
import setItemState from "../setItemState";

export default ({ state, id }) => {
  const newState = setItemState(state, id, ITEM_STATE_TO_BAG_COMPLETE);
  if (newState.items.some(isDeleting) || newState.items.some(isToBagInProgress))
    return newState;

  const items = newState.items.filter(isNotRemoved);

  return {
    ...newState,
    items,
    displayableItemCount: items.length,
    indicatives: {
      ...state.indicatives,
      items: state.indicatives.items
        ? state.indicatives.items.slice(0, items.length)
        : undefined
    }
  };
};
